import { Component, EventEmitter, Output } from '@angular/core';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-upload-csv',
    templateUrl: './upload-csv.template.html',
})
export class UploadCsv extends BaseForm {
    @Output() onFileUpload: EventEmitter<File> = new EventEmitter<File>();
    hasFile: boolean;
    filename: string;
    errors: string[] = [];

    onFileChange(files: FileList): void {
        const file = files[0];
        this.onFileUpload.emit(file);
    }
}
